import { pxToRem } from '../../../teams/utils';
export default (function (siteVars) {
    return {
        backgroundColor: siteVars.bodyBackground,
        border: pxToRem(1) + " solid " + siteVars.bodyColor,
        boxShadow: "0 " + pxToRem(1) + " 0 " + siteVars.accessibleYellow,
        fontColor: siteVars.bodyColor,
        iconColor: siteVars.bodyColor,
        inputFocusBorderBottomColor: siteVars.accessibleYellow,
    };
});
